import { Select } from 'antd';
import { CloseOutlined, DownOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import classnames from 'classnames';

import IntlMessages from '@src/util/IntlMessages';

import { useDivisionSelector } from './hooks/useDivisionSelector';
import styles from './styles.module.less';

const { Option } = Select;

export const DivisionSelector: React.FC<{ desktopTheme?: boolean }> = ({ desktopTheme = false }) => {
  const intl = useIntl();
  const { ALL_DIVS, allSelected, onChangeDivision, orgLoading, selectedDivs, sortedDivisions } =
    useDivisionSelector();
  const showClear = selectedDivs.length > 1 && !allSelected;

  return (
    <div className={styles.wrapper}>
      <Select
        allowClear={showClear}
        aria-label={intl.formatMessage({ id: 'sidebar.nav.divisions' })}
        className={classnames(
          styles.select,
          allSelected && styles.allSelected,
          !showClear && styles.withoutClear,
        )}
        clearIcon={showClear ? <CloseOutlined /> : null}
        dropdownMatchSelectWidth={false}
        loading={orgLoading}
        maxTagCount={1}
        mode="multiple"
        onChange={onChangeDivision}
        optionFilterProp="children"
        placeholder={<IntlMessages id="config.division.name" />}
        popupClassName={classnames(
          styles.dropdownWrapper,
          desktopTheme && styles.dropdownWrapperDesktop,
        )}
        value={allSelected ? [ALL_DIVS] : selectedDivs}
      >
        <Option key={ALL_DIVS} value={ALL_DIVS}>
          <IntlMessages id="divisionSelector.allDivisions" />
        </Option>
        {sortedDivisions.map(div => (
          <Option key={div.id} value={div.id}>
            {div.name ?? ''}
          </Option>
        ))}
      </Select>
      {!showClear ? (
        <span aria-hidden className={styles.dropdownIndicator}>
          <DownOutlined />
        </span>
      ) : null}
    </div>
  );
};
